import React, { useContext, useEffect } from "react";
import { PlanDetailsContext } from "../PlanDetailsView";
import { Col, Container, Row } from "react-bootstrap";
import ContentData from "../../../../constants/contentFile.json";
import Loader from "../../../../components/Loader/Loader";
import NextIcon from "../../../../assets/images/next-icon.svg";
import EditIcon from "../../../../assets/images/editIcon.png";
import DeleteIcon from "../../../../assets/images/deleteIcon.png";
import DeactiveIcon from "../../../../assets/images/deactiveIcon.png";
import ActiveUserIcon from "../../../../assets/images/activeUserIcon.png";
import ExportIcon from "../../../../assets/images/icons/export-icon.svg";
import Accordion from "@mui/material/Accordion";
// import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import "./planDetails.css";
import CheckBox from "../../../../components/CheckBoxComponent/CheckBox";
import SuccessPopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import DeleteAlertBox from "../../../../components/AlertComponent/AlertBox";
import DeletePopupImage from "../../../../assets/images/delete.svg";
import DeactivePopupImage from "../../../../assets/images/deactivePopupIcon.svg";
import StatusAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import DeleteAlertError from "../../../../components/PopupAlertError/PopupAlertError";

const PlanDetails = () => {
  const {
    spinnerStatus,
    planId,
    planStatus,
    planData,
    editPlanData,
    permissionAccess,
    deletePlanManage,
    successPopup,
    successPopupMessage,
    planListPage,
    deleteAlert,
    setDeleteAlert,
    setSuccessPopup,
    errorPopup,
    buttonText,
    errorPopupMessage,
    statusValue,
    setErrorPopup,
    planDetailData,
    deactiveAlert,
    setDeactiveAlert,
    activeAlert,
    setActiveAlert,
    inviteActivePlan,
    activePlanData,
    changeStatus,
    setChangeStatus,

    deleteErrorPopup,
    setDeleteErrorPopup,
    statusErrorPopup,
    setStatusErrorPopup,
    downloadPDF,
    pdfRef,
    onClickExpansion,
  } = useContext(PlanDetailsContext);

  const checkDropdownTrue = () => {
    if (
      document.querySelector("#panel1-header").getAttribute("aria-expanded") ==
      "false"
    ) {
      document.querySelector(".MuiAccordionSummary-root").click();
    } else {
      console.log("Accordion is expanded");
    }
  };

  const PDFplanData = () => {
    checkDropdownTrue();
    setTimeout(() => {
      downloadPDF();
    }, 100);
  };
  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing">
          {ContentData.planManagement.pageTitle}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="breadCrumsPointing">
          {ContentData.planManagement.basicSubscriptionPlans}
        </span>
      </div>

      <Container className="planDetailsContainer">
        {spinnerStatus && <Loader />}
        <div className="flexPage">
          <div className="headFlexing">
            <div className="pageTittles">
              {ContentData.planManagement.basicSubscriptionPlanDetail}
            </div>
            <div className="subFlexing">
              <div>
                <span
                  className="deletEditSection exportButton"
                  onClick={() => {
                    PDFplanData();
                  }}
                >
                  <span className="">{ContentData.planManagement.export}</span>
                  <img src={ExportIcon} alt="Export" />
                </span>
              </div>
              {planData?.status === "A" ? (
                <div
                  className={`deletEditSection ${
                    permissionAccess?.delete ? "" : "disabledIconOnly"
                  }`}
                  onClick={() => {
                    setDeactiveAlert(true);
                    setChangeStatus("I");
                    setActiveAlert(false);
                  }}
                >
                  <img src={DeactiveIcon} alt="DeactiveIcon" />
                </div>
              ) : planData?.status === "I" ? (
                <div>
                  <span
                    className={`activeButton ${
                      permissionAccess?.delete ? "" : "disabledIconOnly"
                    }`}
                  >
                    {ContentData.tenantPage.deactivated}
                  </span>
                  <span
                    className={`deletEditSection ${
                      permissionAccess?.delete ? "" : "disabledIconOnly"
                    }`}
                    onClick={() => {
                      setActiveAlert(true);
                      setChangeStatus("A");
                      setDeactiveAlert(false);
                    }}
                  >
                    <img src={ActiveUserIcon} alt="ActiveUserIcon" />
                  </span>
                </div>
              ) : null}

              <div
                className={`deletEditSection  ${
                  permissionAccess?.edit ? "" : "disabledIconOnly"
                } `}
                onClick={() => editPlanData(planData?._id)}
              >
                <img src={EditIcon} alt="EditIcon" />
              </div>
              <div
                className={`deletEditSection  ${
                  permissionAccess?.delete ? "" : "disabledIconOnly"
                }`}
                onClick={() => {
                  setDeleteAlert(true);
                }}
              >
                <img src={DeleteIcon} alt="DeleteIcon" />
              </div>
            </div>
          </div>
        </div>
        <div ref={pdfRef} style={{ padding: "20px" }}>
          <div className="planDetailSection">
            <div
              style={{
                backgroundColor: "#eceef1",
                width: "100% ",
                borderRadius: "8px",
              }}
            >
              <Row className="planDetailSectionRow1">
                <Col xl="2" lg="6" sm="12">
                  <div className="">
                    <div className=" roleSubPage">
                      <h4>{ContentData.planManagement.totalRevenue}</h4>
                      <div className=" planDetailsData">
                        ₹{planData?.revenue}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xl="2" lg="6" sm="12">
                  <div className=" ">
                    <div className="  roleSubPage">
                      <h4>{ContentData.planManagement.subscriberCount}</h4>
                      <div className=" planDetailsData">
                        {planData?.subscriberCount}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xl="2" lg="6" sm="12">
                  <div className=" ">
                    <div className="  roleSubPage">
                      <h4>{ContentData.planManagement.userCountOnly}</h4>
                      <div className=" planDetailsData">
                        {planData?.userCount}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="planDetailsSpace">
                  <Col xl="2" lg="6" sm="12">
                    <div className=" ">
                      <div className="  roleSubPage">
                        <h4>{ContentData.planManagement.planName}</h4>
                        <div className=" planDetailsData">{planData?.name}</div>
                      </div>
                    </div>
                  </Col>
                  <Col xl="2" lg="6" sm="12">
                    <div className=" ">
                      <div className="roleSubPage">
                        <h4>{ContentData.planManagement.price}</h4>
                        <div className=" planDetailsData">
                          ₹{planData?.price}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col xl="2" lg="6" sm="12">
                    <div className=" ">
                      <div className="  roleSubPage">
                        <h4>{ContentData.planManagement.billing}</h4>
                        <div className=" planDetailsData">
                          {planData?.billingCycle}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Col>
              </Row>
            </div>
            <div>
              <Row className="planDetailSectionRow2">
                <Col xl="2" lg="6" sm="12">
                  <div className=" ">
                    <div className="  roleSubPage">
                      <h4>{ContentData.planManagement.trialPeriod}</h4>
                      <div className=" planDetailsData">
                        {planData?.trialPeriod} days
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xl="2" lg="6" sm="12">
                  <div className=" ">
                    <div className="  roleSubPage">
                      <h4>{ContentData.planManagement.status}</h4>
                      <div
                        className=" planDetailsData"
                        style={{
                          color:
                            planData?.status === "A"
                              ? "#13BC5B" // Green for Active
                              : planData?.status === "I"
                              ? "#EB5757" // Red for Inactive
                              : "#6c757d", // Default color (gray)
                        }}
                      >
                        {planData?.status === "A"
                          ? "Active"
                          : planData?.status === "I"
                          ? "Inactive"
                          : "-"}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xl="8" lg="6" sm="12">
                  <div className="">
                    <div className="  roleSubPage">
                      <h4>{ContentData.planManagement.description}</h4>
                      <div className=" planDetailsData">
                        {planData?.description}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="featureSection">
            <span className="sectionHeading">
              {ContentData.planManagement.features}
            </span>
            <Row
              className="featureData"
              style={{
                padding: "0px",
                margin: "0px",
              }}
            >
              {planData?.features &&
                planData?.features.map((item) => (
                  <Col xl="6" lg="6" sm="12" className="featureElement">
                    <span className="featureHeading">
                      {item?.planFeature?.name}
                    </span>
                    <span>{item?.planFeature?.description}</span>
                  </Col>
                ))}
            </Row>
          </div>
          <div className="tenantListingSection">
            <span className="sectionHeading">
              {ContentData.planManagement.tenantListing}
            </span>
            <Accordion
              defaultExpanded={false}
              className="profileAccordion"
              disableGutters
              elevation={0}
              sx={{
                border: "none",
                "&:before": {
                  display: "none",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{
                  fontSize: "12px",
                  backgroundColor: "#F7F8FA",
                  fontWeight: "bold",
                  color: "#6b7a99",
                  height: "45px",
                }}
              >
                <Row style={{ width: "100%" }}>
                  <Col> {ContentData.planManagement.companyName}</Col>
                  <Col>{ContentData.planManagement.userCountOnly}</Col>
                </Row>
              </AccordionSummary>

              <AccordionDetails sx={{ padding: 0 }}>
                <AccordionDetails sx={{ padding: 0 }}>
                  {planData?.subscribers &&
                    planData?.subscribers.map((item) => (
                      <Row className="plan-details-row">
                        <Col>{item?.organizationName}</Col>
                        <Col>{item?.userCount}</Col>
                      </Row>
                    ))}
                </AccordionDetails>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </Container>
      <SuccessPopupAlert
        show={successPopup}
        alertMessage={successPopupMessage}
        handleSubmit={() => {
          setSuccessPopup(false);
          planListPage();
        }}
      />
      <PopupAlertError
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            planListPage();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            planDetailData(planId);
          }
        }}
      />

      <StatusAlertError
        show={statusErrorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setStatusErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            planListPage();
            setStatusErrorPopup(false);
          } else {
            setStatusErrorPopup(false);
            activePlanData(planData._id, changeStatus);
          }
        }}
      />

      <DeleteAlertError
        show={deleteErrorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setDeleteErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            planListPage();
            setDeleteErrorPopup(false);
          } else {
            setDeleteErrorPopup(false);
            deletePlanManage(planData?._id);
          }
        }}
      />

      <DeleteAlertBox
        alertMessage={ContentData.planManagement.deleteSure}
        buttonSubmitText={ContentData.rolePermissions.deleteText}
        popImage={DeletePopupImage}
        show={deleteAlert}
        setShow={setDeleteAlert}
        handleSubmitData={() => deletePlanManage(planData?._id)}
        handleCancelClick={() => setDeleteAlert(false)}
      />
      {deactiveAlert && (
        <DeleteAlertBox
          alertMessage={ContentData.planManagement.deactiveUserText}
          buttonSubmitText={ContentData.adminPage.deactiveText}
          popImage={DeactivePopupImage}
          show={deactiveAlert}
          setShow={setDeactiveAlert}
          handleSubmitData={() => activePlanData(planData._id, changeStatus)}
          handleCancelClick={() => setDeactiveAlert(false)}
        />
      )}
      {activeAlert && (
        <DeleteAlertBox
          alertMessage={ContentData.planManagement.activeUserText}
          buttonSubmitText={"Activate"}
          popImage={DeactivePopupImage}
          show={activeAlert}
          setShow={setActiveAlert}
          handleSubmitData={() => activePlanData(planData._id, changeStatus)}
          handleCancelClick={() => setActiveAlert(false)}
        />
      )}
    </div>
  );
};

export default PlanDetails;
